type SearchableOption = { label: string; group?: string };

/**
 * A predicate for one search pass. The query is normalised here rather than inside the predicate
 * so it happens once per filter rather than once per option.
 */
export function optionMatcher(
  query: string
): (option: SearchableOption) => boolean {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return () => true;
  // Group names match too: grouped options (e.g. ports) carry their country in the header
  // rather than the label, and searching by it should work.
  return (option) =>
    option.label.toLowerCase().includes(trimmed) ||
    (option.group?.toLowerCase().includes(trimmed) ?? false);
}
